const typography = {
  fontFamily: '"Roboto", sans-serif',
};

export default typography;
